import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateBoxDialogComponent } from '../create-box-dialog/create-box-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { Box } from "../../../model/box";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { BoxesService } from "../../../services/boxes-service";
import { Contract } from "../../../model/contract";
import { Constants } from "../../../utils/constants";
import { AddResearchersDialogComponent } from "../add-researchers-dialog/add-researchers-dialog.component";
import { BoxDialogComponent } from "../box-dialog/box-dialog.component";
import { AuthService } from "../../../services/auth.service";
import { AddCertificateDialogComponent } from "../add-certificate-dialog/add-certificate-dialog.component";
import { AddBoxInterfaceDialogComponent } from "../add-box-interface-dialog/add-box-interface-dialog.component";
import { AddSimDialogComponent } from "../add-sim-dialog/add-sim-dialog.component";
import { SimsService } from "../../../services/sims.service";
import { BoxCertificatesService } from "../../../services/box-certificates.service";
import { StatusLegendDialogComponent } from "../../../shared-components/status-dialog/status-legend-dialog.component";
import { BoxInterfaceInfoDialogComponent } from '../box-interface-info-dialog/box-interface-info-dialog.component';


@Component({
  selector: 'aw-list-boxes',
  templateUrl: './list-boxes.component.html',
  styleUrls: ['./list-boxes.component.scss']
})
export class ListBoxesComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'identifier',
    'hardwareVersion',
    'softwareVersion',
    // 'contract',
    'server',
    'logisticsStatus',
    'sim',
    'enabled',
    // 'interfaces',
    // 'events',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  iAmCustomer = false;
  @ViewChild('paginatorBoxes') paginatorUsers!: MatPaginator;
  @Input() contract?: Contract;
  @Input() embeddedLayout = false;

  dataSource!: MatTableDataSource<Box>;
  expandedBoxEventsHistory?: Box;
  expandedResearchers?: Box;
  expandedCertificates?: Box;
  expandedInterfaces?: Box;
  expandedSim?: Box;
  entities = Constants.entities;
  contractStatus = Constants.contractStatuses;
  boxStatus = Constants.boxStatuses;
  certificateStatus = Constants.certificateStatuses;
  roles = Constants.roles;
  loggedUser?: any;
  private allBoxes$!: Observable<Box[]>;

  constructor(
    public dialog: MatDialog,
    public dialogsService: DialogsService,
    public authService: AuthService,
    private boxesService: BoxesService,
    private simsService: SimsService,
    private boxCertificatesService: BoxCertificatesService,
    private snackService: SnackService
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
    this.iAmCustomer = this.loggedUser.role === this.roles.customer;
  }

  ngAfterViewInit(): void {
    this.allBoxes$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (this.iAmCustomer || this.contract)
              return this.boxesService.getAllBoxesByContract(this.contract);

            return this.boxesService.getAllBoxes();
          }),
          tap(boxes => {
            this.dataSource = new MatTableDataSource<Box>(boxes);
            this.dataSource.paginator = this.paginatorUsers;

            boxes.forEach(box => {

              box.currentCertificate = box?.boxCertificates?.find(certificate =>
                certificate?.status !== this.certificateStatus.expired &&
                certificate?.status !== this.certificateStatus.revoked);
            });

            this.loading = false;
          })
        );
    this.allBoxes$.subscribe();
  }

  expandEvents(element: Box): void {
    this.expandedBoxEventsHistory != element ?
      this.expandedBoxEventsHistory = element :
      this.expandedBoxEventsHistory = undefined;

    this.expandedSim = undefined;
    this.expandedResearchers = undefined;
    this.expandedInterfaces = undefined;
    this.expandedCertificates = undefined;
  }

  expandResearchers(element: Box): void {
    this.expandedResearchers != element ?
      this.expandedResearchers = element :
      this.expandedResearchers = undefined;

    this.expandedSim = undefined;
    this.expandedInterfaces = undefined;
    this.expandedCertificates = undefined;
    this.expandedBoxEventsHistory = undefined;
  }

  expandCertificates(element: Box): void {
    this.expandedCertificates != element ?
      this.expandedCertificates = element :
      this.expandedCertificates = undefined;

    this.expandedSim = undefined;
    this.expandedResearchers = undefined;
    this.expandedInterfaces = undefined;
    this.expandedBoxEventsHistory = undefined;
  }

  expandBoxInterfaces(element: Box): void {
    this.expandedInterfaces != element ?
      this.expandedInterfaces = element :
      this.expandedInterfaces = undefined;

    this.expandedSim = undefined;
    this.expandedCertificates = undefined;
    this.expandedResearchers = undefined;
    this.expandedBoxEventsHistory = undefined;
  }

  expandSim(element: Box): void {
    this.expandedSim != element ?
      this.expandedSim = element :
      this.expandedSim = undefined;

    this.expandedCertificates = undefined;
    this.expandedInterfaces = undefined;
    this.expandedResearchers = undefined;
    this.expandedBoxEventsHistory = undefined;
  }


  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortBoxes(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      const index: string = event.active;

      if (event.active === 'certificate') {
        if (event.direction === 'asc') {
          return ('' + b.currentCertificate?.endDate).localeCompare('' + a.currentCertificate?.endDate);
        } else {
          return ('' + a.currentCertificate?.endDate).localeCompare('' + b.currentCertificate?.endDate);
        }
      }

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(box: Box): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: box });
  }

  createBox(): void {
    this.disabled = true;
    this.dialog
      .open(CreateBoxDialogComponent, { data: new Box() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editBox(box: Box): void {
    this.disabled = true;
    this.dialog
      .open(CreateBoxDialogComponent, { data: box })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  deleteBox(box: Box): void {
    this.disabled = true;
    const id = box.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete box', `Are you sure you want to delete the box "${box.identifier}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxesService.deleteBox(<number>box.id) :
          EMPTY),
        switchMap(() => this.allBoxes$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Box deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  addResearchers(box: Box): void {
    this.disabled = true;
    this.dialog
      .open(AddResearchersDialogComponent, { data: box })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });

  }

  addCertificate(box: Box): void {
    this.disabled = true;
    this.dialog
      .open(AddCertificateDialogComponent, { data: box })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });

  }

  addBoxInterfaces(box: Box): void {
    this.disabled = true;
    this.dialog
      .open(AddBoxInterfaceDialogComponent, { data: box })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });

  }


  performAction(box: Box, enabled: boolean): void {
    this.disabled = true;
    this.dialog.open(BoxDialogComponent, { data: { box: box, enable: enabled } })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }


  assignSim(box: Box): void {
    this.disabled = true;
    this.dialog
      .open(AddSimDialogComponent, { data: box })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allBoxes$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });

  }

  removeSim(box: Box): void {
    this.disabled = true;
    this.dialogsService
      .confirm('Remove sim', `Are you sure you want to remove the sim "${box.sim?.identifier}" from the box "${box?.identifier}"?`)
      .pipe(
        switchMap((value) => value ? this.simsService.deleteSimAssociation(<number>box.id) : EMPTY),
        switchMap(() => this.allBoxes$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Sim removed!');
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
      },
        () => {
          this.disabled = false;
        });

  }

  removeCertificate(box: Box): void {
    this.disabled = true;
    this.dialogsService
      .confirm('Remove certificate', `Are you sure you want to remove the box certificate "${box.currentCertificate?.cmId}" from the box "${box.identifier}"?`)
      .pipe(
        switchMap((value) => value ?
          this.boxCertificatesService.dissociateCertificate(<number>box?.id, <number>box.currentCertificate?.id) :
          EMPTY),
        switchMap(() => this.allBoxes$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Box certificate removed!');
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
      },
        () => {
          this.disabled = false;
        });

  }

  getTooltip(box: Box): string {
    switch (box.status) {
      case Constants.boxStatuses.onTheShelf:
        return Constants.boxStatusesExplainedForLegend.onTheShelf;
      case Constants.boxStatuses.toBeConfigured:
        return Constants.boxStatusesExplainedForLegend.toBeConfigured;
      case Constants.boxStatuses.broken:
        return Constants.boxStatusesExplainedForLegend.broken;
      case Constants.boxStatuses.updating:
        return Constants.boxStatusesExplainedForLegend.updating;
      case Constants.boxStatuses.assigned:
        return `The box has been assigned to the contract "${box.contract?.title}" and is ready to be shipped.`;
      case Constants.boxStatuses.shipped:
        return `The box has been shipped to customer's company "${box.contract?.company?.companyName}".`;
      case Constants.boxStatuses.delivered:
        return Constants.boxStatusesExplainedForLegend.delivered;
      case Constants.boxStatuses.mounted:
        return Constants.boxStatusesExplainedForLegend.mounted;
      case Constants.boxStatuses.available:
        return Constants.boxStatusesExplainedForLegend.available;
      case Constants.boxStatuses.unavailable:
        return Constants.boxStatusesExplainedForLegend.unavailable;
      case Constants.boxStatuses.inUse:
        return Constants.boxStatusesExplainedForLegend.inUse;
      case Constants.boxStatuses.fail:
        return Constants.boxStatusesExplainedForLegend.fail;
      case Constants.boxStatuses.toShipBack:
        return Constants.boxStatusesExplainedForLegend.toShipBack;
      case Constants.boxStatuses.goingHome:
        return Constants.boxStatusesExplainedForLegend.goingHome;
      default:
        return 'not implemented!';
    }

  }

  statusDetails(): void {
    this.disabled = true;
    this.dialog.open(StatusLegendDialogComponent, { data: { contract: false, box: true } })
      .afterClosed()
      .pipe()
      .subscribe(
        () => {
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  showBoxInfo(box: Box) {
    this.dialog.open(BoxInterfaceInfoDialogComponent, {
      data : {
        contract: this.contract.id,
        box: box
      }
    })
  }

}
